import type { SVGProps } from 'react';

export const ListBulletCircleSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.5381 20.1848"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="20.1848" opacity="0" width="20.5381" x="0" y="0" />{' '}
        <path
          d="M10.0875 20.175C15.6576 20.175 20.1767 15.6559 20.1767 10.0875C20.1767 4.51914 15.6576 0 10.0875 0C4.51914 0 0 4.51914 0 10.0875C0 15.6559 4.51914 20.175 10.0875 20.175ZM10.0875 18.1879C5.60839 18.1879 1.9871 14.5666 1.9871 10.0875C1.9871 5.60839 5.60839 1.9871 10.0875 1.9871C14.5666 1.9871 18.1897 5.60839 18.1897 10.0875C18.1897 14.5666 14.5666 18.1879 10.0875 18.1879Z"
          fill="currentColor"
        />{' '}
        <path
          d="M7.87694 7.57558L14.8531 7.57558C15.2045 7.57558 15.4822 7.30409 15.4822 6.95448C15.4822 6.59687 15.2045 6.32714 14.8531 6.32714L7.87694 6.32714C7.52733 6.32714 7.25936 6.60487 7.25936 6.95448C7.25936 7.29608 7.5371 7.57558 7.87694 7.57558ZM7.87694 13.8559L14.8531 13.8559C15.2045 13.8559 15.4822 13.5861 15.4822 13.2365C15.4822 12.8771 15.2045 12.6074 14.8531 12.6074L7.87694 12.6074C7.5371 12.6074 7.25936 12.8949 7.25936 13.2365C7.25936 13.5861 7.52909 13.8559 7.87694 13.8559ZM7.87694 10.7166L14.8531 10.7166C15.2045 10.7166 15.4822 10.4451 15.4822 10.0955C15.4822 9.73789 15.2045 9.4664 14.8531 9.4664L7.87694 9.4664C7.53534 9.4664 7.25936 9.7539 7.25936 10.0955C7.25936 10.4371 7.5371 10.7166 7.87694 10.7166ZM5.52343 7.81718C5.99296 7.81718 6.38612 7.41601 6.38612 6.95448C6.38612 6.47694 6.00096 6.09355 5.52343 6.09355C5.04589 6.09355 4.66073 6.47694 4.66073 6.95448C4.66073 7.42577 5.04589 7.81718 5.52343 7.81718ZM5.52343 10.9582C5.99296 10.9582 6.38612 10.557 6.38612 10.0955C6.38612 9.62597 5.99296 9.23281 5.52343 9.23281C5.04589 9.23281 4.66073 9.61796 4.66073 10.0955C4.66073 10.565 5.04589 10.9582 5.52343 10.9582ZM5.52343 14.0975C6.00096 14.0975 6.38612 13.7061 6.38612 13.2365C6.38612 12.767 5.99296 12.3738 5.52343 12.3738C5.04589 12.3738 4.66073 12.7572 4.66073 13.2365C4.66073 13.7061 5.04589 14.0975 5.52343 14.0975Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
